import './DataBlock.css'
import { InfoTooltip } from '../InfoTooltip/InfoTooltip'
import cx from 'classnames'
import { Spinner } from '../Spinner/Spinner'

const dataVariantClasses = {
  default: 'data-block-data-default',
  info: 'data-block-data-info'
}

export function DataBlock({
  label,
  data,
  tooltip,
  variant = 'default',
  dense = false,
  isLoading = false,
  details
}: {
  label: React.ReactNode
  data?: React.ReactNode
  tooltip?: string
  variant?: keyof typeof dataVariantClasses
  dense?: boolean
  isLoading?: boolean
  details?: React.ReactNode
}) {
  return (
    <div className={cx('data-block', dense ? 'data-block-dense' : 'data-block-default')}>
      <div className="data-block-label">
        {label} {tooltip && <InfoTooltip size="small" content={tooltip} />}
      </div>
      <div className={cx(dataVariantClasses[variant], 'flex flex-col gap-1')}>
        <div className="flex flex-wrap gap-x-1 gap-y-1">
          {isLoading ? <Spinner className="size-5 mt-2" /> : data}
          {details != null && details}
        </div>
      </div>
    </div>
  )
}
